<template>
  <div>
    <div class="modal-dialog" v-if="notification">
      <div class="modal-content">
        <div class="modal-header">
          <template v-if="notification.type==='error'">
            <base-icon name="alert-octagon"></base-icon>
            <h5 class="modal-title">{{ notification.title }}</h5>
          </template>
          <template v-if="notification.type==='success'">
            <base-icon name="check-circle"></base-icon>
            <h5 class="modal-title">{{ notification.title }}</h5>
          </template>
          <button type="button" class="close" @click="closeNotification">
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>{{ notification.message }}</p>
        </div>
      </div>
    </div>
    <!-- .modal-dialog -->
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      timeout: null
    }
  },
  props: {
    notification: {
      type: Object,
      required: true
    }
  },
  computed: {
    notificationTypeClass() {
      let notificationClass = 'alert-secondary'
      this.notification.type == 'error'
        ? (notificationClass = 'alert-warning')
        : notificationClass
      this.notification.type == 'success'
        ? (notificationClass = 'alert-success')
        : notificationClass

      return `${notificationClass}`
    }
  },
  methods: {
    ...mapActions('notification', ['remove']),
    closeNotification() {
      clearTimeout(this.timeout)
      this.remove(this.notification)
      document.body.classList.remove('modal-open')
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
    document.body.classList.remove('modal-open')
  },
  mounted() {
    this.timeout = setTimeout(() => this.remove(this.notification), 4000)
    document.body.classList.add('modal-open')
  }
}
</script>

<style scoped>
.modal-dialog {
  z-index: 1200;
}
</style>
